import React, { useContext, useEffect } from "react";
import HomeWrapper from "../HomeWrapper";
import ChatWindow from "../ChatWindow";
import { ChatContext } from "../ChatContextProvider";
import ConversationHistory from "../ConversationHistory";
import VideoCallWrapper from "../VideoCallWrapper";

const ChatContainer = () => {
  const { appState, callState } = useContext(ChatContext);

  useEffect(()=>{
    console.log("callState?.state", callState)
  },[callState]);

  return (
    <div
      className={`w-full h-full ${
        callState?.state === "incoming"
          ? "grid grid-cols-6 gap-2"
          : callState?.state === "accepted"
          ? "grid grid-cols-10 gap-2 backdrop-blur-xl"
          : "flex bg-white"
      }`}
    >
      {callState?.state && callState?.state !== "finished" && (
        <VideoCallWrapper />
      )}
      <div
        className={`w-full h-full relative max-h-lvh ${
          callState?.state && callState?.state !== "finished"
            ? "col-span-3"
            : ""
        }`}
      >
          {appState.currentScreen === "home" && <HomeWrapper />}
          {appState.currentScreen === "chat" && <ChatWindow />}
          {appState.currentScreen === "conversations" && (
            <ConversationHistory />
          )}
      </div>
    </div>
  );
};

export default ChatContainer;
